/**
 * CPF mascarado para exibição na confirmação de cadastro (Figma 1669:3076).
 *
 * Mantém apenas o grupo do meio visível — `***.414.***-**` — para confirmar a
 * identidade sem expor o documento completo numa tela pública.
 */
export function maskCpfForDisplay(raw: string | null | undefined): string {
  const digits = (raw ?? '').replace(/\D/g, '');
  if (digits.length !== 11) return '';
  return `***.${digits.slice(3, 6)}.***-**`;
}
